<!-- 転職時期選択スライド -->
<script setup lang="ts">
import { ref, computed, watch, nextTick } from 'vue';

import type Inquiry from '@/javascripts/utils/inquiry';
import { getWishfulTimes } from '@/javascripts/utils/inquiry_form_options';

import type { InquiryValidation } from '@/javascripts/composables/inquiry/validation';

/** プロパティ */
const props = defineProps<{
  /** 問い合わせオブジェクト */
  wishfulTimeCd: Inquiry['wishfulTimeCd'],
  /** 問い合わせバリデーション */
  v$: InquiryValidation,
}>();

/** カスタムイベント */
const emit = defineEmits([
  'back', 
  'next', 
  'update:wishful-time-cd'
]);

/** フォーム項目の computed プロパティ */
const localWishfulTimeCd = computed({
  get: () => props.wishfulTimeCd,
  set: (value) => emit('update:wishful-time-cd', value)
}); 

/** 転職時期の選択肢リスト */
const wishfulTimes = getWishfulTimes();

/** 「次へ」ボタン */
const nextButton = ref<HTMLButtonElement | null>();

/** 転職時期のバリデーション結果 */
const invalid = computed(() => props.v$.wishfulTimeCd.$invalid);

// 転職時期変更時にエラーがなければ`next`イベントを発火
watch(localWishfulTimeCd, async () => {
  if(!invalid.value) {
    // 「次へ」ボタンが有効になるのを待つ
    await nextTick();

    nextButton.value?.click();
  }
});
</script>

<template>
  <div class="slide_body">
    <div class="option_wrap">
      <h3 class="option_title required">
        ご希望の転職時期はいつ頃ですか？
      </h3>
      <div class="option_group">
        <div
          v-for="wishfulTime in wishfulTimes"
          :key="wishfulTime.cd"
          class="option_input"
        >
          <input
            :id="`wishful_time_cd_${wishfulTime.cd}`"
            v-model="localWishfulTimeCd"
            type="radio"
            name="wishful_time"
            :value="wishfulTime.cd"
            required
          >
          <label
            :for="`wishful_time_cd_${wishfulTime.cd}`"
          >{{ wishfulTime.text }}</label>
        </div>
      </div>
      <div
        v-for="(error, key) in v$.wishfulTimeCd.$errors"
        :key="key"
        class="validation_message_box"
      >{{ error.$message }}</div>
    </div>
    <div class="slide_control_group">
      <a
        id="ph_back_1"
        class="back_link"
        @click="emit('back')"
      >&lt; 戻る</a>
      <button
        id="ph_next_2"
        ref="nextButton"
        :disabled="invalid"
        class="form_button"
        @click="emit('next')"
      >
        次へ
      </button>
    </div>
  </div>
</template>